import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import 'parsleyjs';
import $ from 'jquery';
import {loginUser, registerAccount} from '../../api/auth';

const Register = (props) => {

    document.title = "Register";

    useEffect(() => {
        $('#register').parsley();
        return () => {
            $('#register').parsley("destroy");
        }
    }, [])

    const dispatch = useDispatch();

    //Selector
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const [stateReady, setStateReady] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = {
            name: $('#name').val(),
            email: $('#email').val(),
            contact_number: $('#contact-number').val(),
            password: $('#password').val(),
        };

        setStateReady(true);
        dispatch(registerAccount(data)).then(() => {
            setStateReady(false);
        });
    };

    if(isAuthenticated) {
        props.history.push('/investment');
    }

    return(
        <div id="register-wrapper">
            <div className="vh-100 d-flex justify-content-center align-items-center">
                <div className="bg-white mx-auto my-auto col-12 col-sm-3 col-md-3" style={{borderRadius: '12px', padding: 30}}>
                    <div className="text-center">
                        <img src="/assets/images/logo.svg" className="mg-b-20 img-fluid" alt="logo"/>
                        <h3>Registration</h3>
                    </div>
                    <form id="register" className="parsley-style-1 mt-4" data-parsley-validate="true" onSubmit={handleSubmit.bind()}>
                        <div id="nameWrapper" className="form-group parsley-input">
                            <label>Full Name</label>
                            <input id="name" type="text" className="form-control"
                                   placeholder="Enter full name"
                                   autoComplete="off"
                                   data-parsley-class-handler="#nameWrapper" required/>
                        </div>

                        <div id="mobileWrapper" className="form-group parsley-input">
                            <label>Contact Number</label>
                            <input id="contact-number" type="number" className="form-control"
                                   placeholder="Enter your contact number"
                                   autoComplete="off"
                                   data-parsley-class-handler="#mobileWrapper" required/>
                        </div>

                        <div id="emailWrapper" className="form-group parsley-input">
                            <label>Email address</label>
                            <input id="email" type="email" className="form-control"
                                   placeholder="Enter your email address"
                                   autoComplete="off"
                                   data-parsley-class-handler="#emailWrapper" required/>
                        </div>

                        <div id="passwordWrapper" className="form-group parsley-input mt-4">
                            <div className="mg-b-5">
                                <label className="mg-b-0-f">Create Password</label>
                            </div>
                            <input id="password" type="password" className="form-control"
                                   placeholder="Enter new password"
                                   data-parsley-minlength="6"
                                   autoComplete="off"
                                   data-parsley-class-handler="#passwordWrapper" required/>
                        </div>
                        {stateReady ? <button className="btn btn-secondary btn-block" disabled><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Loading</button> : <button className="btn btn-primary btn-block">Sign Up</button>}
                    </form>
                    <div className="text-center mt-3">
                        <a href="#/login">Already have an account? Login</a>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Register;
